{
  "nm": "Comp 1",
  "ddd": 0,
  "h": 512,
  "w": 512,
  "meta": { "g": "@lottiefiles/toolkit-js 0.33.2" },
  "layers": [
    {
      "ty": 0,
      "nm": "trait",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [15, 15, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [263.334, 471.109, 0], "ix": 2 },
        "r": { "a": 0, "k": 90, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_0",
      "ind": 1
    },
    {
      "ty": 0,
      "nm": "trait",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [15, 15, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [51.641, 253.275, 0], "ix": 2 },
        "r": { "a": 0, "k": -180, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_0",
      "ind": 2
    },
    {
      "ty": 0,
      "nm": "trait",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [15, 15, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [266.322, 44.315, 0], "ix": 2 },
        "r": { "a": 0, "k": -90, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_0",
      "ind": 3
    },
    {
      "ty": 0,
      "nm": "trait",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [15, 15, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [469.91, 258.792, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_0",
      "ind": 4
    },
    {
      "ty": 0,
      "nm": "firefly",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [20, 20, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [400.635, 189.708, 0], "ix": 2 },
        "r": { "a": 0, "k": -18.097, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_1",
      "ind": 5
    },
    {
      "ty": 0,
      "nm": "firefly",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [20, 20, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [359.413, 150.912, 0], "ix": 2 },
        "r": { "a": 0, "k": -72.471, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_1",
      "ind": 6
    },
    {
      "ty": 0,
      "nm": "firefly",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [30, 30, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [396.894, 150.961, 0], "ix": 2 },
        "r": { "a": 0, "k": -45.707, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_1",
      "ind": 7
    },
    {
      "ty": 0,
      "nm": "trait 2",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [-19.512, 19.512, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [410.865, 406.53, 0], "ix": 2 },
        "r": { "a": 0, "k": -135.205, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_2",
      "ind": 8
    },
    {
      "ty": 0,
      "nm": "trait 2",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [-19.512, 19.512, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [105.535, 402.598, 0], "ix": 2 },
        "r": { "a": 0, "k": -45.606, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_2",
      "ind": 9
    },
    {
      "ty": 0,
      "nm": "trait 2",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [19.512, 19.512, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [104.864, 111.71, 0], "ix": 2 },
        "r": { "a": 0, "k": -135.205, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_2",
      "ind": 10
    },
    {
      "ty": 0,
      "nm": "trait 2",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [256, 256, 0], "ix": 1 },
        "s": { "a": 0, "k": [19.512, 19.512, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [416.722, 113.206, 0], "ix": 2 },
        "r": { "a": 0, "k": -45.606, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "w": 512,
      "h": 512,
      "refId": "comp_2",
      "ind": 11
    },
    {
      "ty": 4,
      "nm": "Shape Layer 2",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [69.59, 69.59, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [236.888, 240.258, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Shape 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Group",
              "nm": "Path 1",
              "ix": 1,
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-76.426, 37.999],
                    [12.056, 114.074],
                    [169.991, -68.635]
                  ]
                },
                "ix": 2
              }
            },
            {
              "ty": "st",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Stroke",
              "nm": "Stroke 1",
              "lc": 2,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 35, "ix": 5 },
              "c": { "a": 0, "k": [1, 1, 1], "ix": 3 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [-7, 11], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        },
        {
          "ty": "tm",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Filter - Trim",
          "nm": "Trim Paths 1",
          "ix": 2,
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0.167, "y": 0 },
                "i": { "x": 0.833, "y": -2.986 },
                "s": [0],
                "t": 0
              },
              {
                "o": { "x": 0.167, "y": 0.042 },
                "i": { "x": 0, "y": 0.973 },
                "s": [0],
                "t": 14.791
              },
              {
                "o": { "x": 0.828, "y": 0.011 },
                "i": { "x": 0.833, "y": 0.833 },
                "s": [32],
                "t": 19.791
              },
              { "s": [100], "t": 24.7912510097683 }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "s": { "a": 0, "k": 0, "ix": 1 },
          "m": 1
        }
      ],
      "ind": 12
    },
    {
      "ty": 4,
      "nm": "Shape Layer 1",
      "sr": 1,
      "st": 0,
      "op": 150.000006109625,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [80, 80, 100], "ix": 6 },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [256, 256, 0], "ix": 2 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100, "ix": 11 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "mn": "ADBE Vector Group",
          "nm": "Ellipse 1",
          "ix": 1,
          "cix": 2,
          "np": 2,
          "it": [
            {
              "ty": "el",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Shape - Ellipse",
              "nm": "Ellipse Path 1",
              "d": 1,
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.654, "y": 0.007 },
                    "i": { "x": 0.976, "y": 0.968 },
                    "s": [0, 0],
                    "t": 0
                  },
                  {
                    "o": { "x": 0.346, "y": -4.83 },
                    "i": { "x": 0.468, "y": 1.057 },
                    "s": [401.025, 401.025],
                    "t": 7
                  },
                  {
                    "o": { "x": 0.364, "y": 0.031 },
                    "i": { "x": 0.375, "y": 1.543 },
                    "s": [372.7, 372.7],
                    "t": 12
                  },
                  {
                    "o": { "x": 0.327, "y": -8.038 },
                    "i": { "x": 0.833, "y": 1 },
                    "s": [401.025, 401.025],
                    "t": 16
                  },
                  { "s": [401.025, 401.025], "t": 20.0000008146167 }
                ],
                "ix": 2
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Graphic - Fill",
              "nm": "Fill 1",
              "c": { "a": 0, "k": [0.1373, 0.6863, 0.3255], "ix": 4 },
              "r": 1,
              "o": { "a": 0, "k": 100, "ix": 5 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "p": { "a": 0, "k": [5.992, 3.49], "ix": 2 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "o": { "a": 0, "k": 100, "ix": 7 }
            }
          ]
        }
      ],
      "ind": 13
    }
  ],
  "v": "5.0.1",
  "fr": 29.9700012207031,
  "op": 45.0000018328876,
  "ip": 0,
  "assets": [
    {
      "nm": "",
      "id": "comp_0",
      "layers": [
        {
          "ty": 4,
          "nm": "Shape Layer 1",
          "sr": 1,
          "st": 0,
          "op": 150.000006109625,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
            "sk": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [256, 256, 0], "ix": 2 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "sa": { "a": 0, "k": 0 },
            "o": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0.167, "y": 0.167 },
                  "i": { "x": 0.572, "y": 0.556 },
                  "s": [100],
                  "t": 7
                },
                {
                  "o": { "x": 0.641, "y": 0.056 },
                  "i": { "x": 0.833, "y": 0.833 },
                  "s": [92.154],
                  "t": 13
                },
                { "s": [30], "t": 17.0000006924242 }
              ],
              "ix": 11
            }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Group",
              "nm": "Shape 1",
              "ix": 1,
              "cix": 2,
              "np": 2,
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "mn": "ADBE Vector Shape - Group",
                  "nm": "Path 1",
                  "ix": 1,
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": false,
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-230, 4],
                        [214, 4]
                      ]
                    },
                    "ix": 2
                  }
                },
                {
                  "ty": "st",
                  "bm": 0,
                  "hd": false,
                  "mn": "ADBE Vector Graphic - Stroke",
                  "nm": "Stroke 1",
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 70, "ix": 5 },
                  "c": { "a": 0, "k": [0.1373, 0.6863, 0.3255], "ix": 3 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "o": { "a": 0, "k": 100, "ix": 7 }
                }
              ]
            },
            {
              "ty": "tm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Trim",
              "nm": "Trim Paths 1",
              "ix": 2,
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.457, "y": 0.063 },
                    "i": { "x": 0.566, "y": 0.999 },
                    "s": [0],
                    "t": 7
                  },
                  { "s": [100], "t": 16.0000006516934 }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.167, "y": 0.167 },
                    "i": { "x": 0.588, "y": -51709.363 },
                    "s": [0],
                    "t": 7
                  },
                  {
                    "o": { "x": 0.509, "y": 0.003 },
                    "i": { "x": 0.696, "y": 0.999 },
                    "s": [0],
                    "t": 10
                  },
                  { "s": [100], "t": 16.0000006516934 }
                ],
                "ix": 1
              },
              "m": 1
            }
          ],
          "ind": 1
        }
      ]
    },
    {
      "nm": "",
      "id": "comp_1",
      "layers": [
        {
          "ty": 4,
          "nm": "Shape Layer 1",
          "sr": 1,
          "st": 0,
          "op": 150.000006109625,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
            "sk": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [256, 256, 0], "ix": 2 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "sa": { "a": 0, "k": 0 },
            "o": { "a": 0, "k": 100, "ix": 11 }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Group",
              "nm": "Ellipse 1",
              "ix": 1,
              "cix": 2,
              "np": 2,
              "it": [
                {
                  "ty": "el",
                  "bm": 0,
                  "hd": false,
                  "mn": "ADBE Vector Shape - Ellipse",
                  "nm": "Ellipse Path 1",
                  "d": 1,
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0, "y": 0.997 },
                        "s": [40, 40],
                        "t": 24
                      },
                      {
                        "o": { "x": 0.574, "y": -0.004 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [90, 90],
                        "t": 27
                      },
                      { "s": [18.394, 18.394], "t": 38.0000015477717 }
                    ],
                    "ix": 2
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "mn": "ADBE Vector Graphic - Fill",
                  "nm": "Fill 1",
                  "c": { "a": 0, "k": [1, 1, 1], "ix": 4 },
                  "r": 1,
                  "o": { "a": 0, "k": 100, "ix": 5 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.667, "y": 1 },
                        "s": [-181.074, -5.414],
                        "t": 24,
                        "ti": [-26.72825050354, 0],
                        "to": [34.0465698242188, 0]
                      },
                      { "s": [200, -5.414], "t": 38.0000015477717 }
                    ],
                    "ix": 2
                  },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [0],
                        "t": 24
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [100],
                        "t": 25
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [100],
                        "t": 29
                      },
                      { "s": [0], "t": 38.0000015477717 }
                    ],
                    "ix": 7
                  }
                }
              ]
            }
          ],
          "ind": 1
        }
      ]
    },
    {
      "nm": "",
      "id": "comp_2",
      "layers": [
        {
          "ty": 4,
          "nm": "Shape Layer 1",
          "sr": 1,
          "st": 0,
          "op": 150.000006109625,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 },
            "sk": { "a": 0, "k": 0 },
            "p": { "a": 0, "k": [256, 256, 0], "ix": 2 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "sa": { "a": 0, "k": 0 },
            "o": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0.167, "y": 0.167 },
                  "i": { "x": 0.572, "y": 0.556 },
                  "s": [100],
                  "t": 10
                },
                {
                  "o": { "x": 0.641, "y": 0.056 },
                  "i": { "x": 0.833, "y": 0.833 },
                  "s": [92.154],
                  "t": 16
                },
                { "s": [30], "t": 20.0000008146167 }
              ],
              "ix": 11
            }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Group",
              "nm": "Shape 1",
              "ix": 1,
              "cix": 2,
              "np": 2,
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "mn": "ADBE Vector Shape - Group",
                  "nm": "Path 1",
                  "ix": 1,
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": false,
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-230, 4],
                        [214, 4]
                      ]
                    },
                    "ix": 2
                  }
                },
                {
                  "ty": "st",
                  "bm": 0,
                  "hd": false,
                  "mn": "ADBE Vector Graphic - Stroke",
                  "nm": "Stroke 1",
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 70, "ix": 5 },
                  "c": { "a": 0, "k": [0.1373, 0.6863, 0.3255], "ix": 3 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "o": { "a": 0, "k": 100, "ix": 7 }
                }
              ]
            },
            {
              "ty": "tm",
              "bm": 0,
              "hd": false,
              "mn": "ADBE Vector Filter - Trim",
              "nm": "Trim Paths 1",
              "ix": 2,
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.457, "y": 0.063 },
                    "i": { "x": 0.566, "y": 0.999 },
                    "s": [0],
                    "t": 10
                  },
                  { "s": [100], "t": 19.0000007738859 }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0.167, "y": 0.167 },
                    "i": { "x": 0.588, "y": -51709.363 },
                    "s": [0],
                    "t": 10
                  },
                  {
                    "o": { "x": 0.509, "y": 0.003 },
                    "i": { "x": 0.696, "y": 0.999 },
                    "s": [0],
                    "t": 13
                  },
                  { "s": [100], "t": 19.0000007738859 }
                ],
                "ix": 1
              },
              "m": 1
            }
          ],
          "ind": 1
        }
      ]
    }
  ]
}
